// extracted by mini-css-extract-plugin
export default {"input":"input-email_input__wQOWA","input__outer":"input-email_input__outer__RrT39"};